import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { useDateLocale, useScreen, useTimeZone } from '../../../../../hooks'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import { InputSelect, InputSelectControl } from '../../../../Select'
import {
  QA_NAME_VIEWING_FORM_SLOT,
  VIEWING_FORM_FIELD_NAME,
} from '../../RentalPortalViewingFormModal.constants'
import { ViewingFormSlotSelectDropdownEmpty } from '../ViewingFormSlotSelectDropdownEmpty'

import { VIEWING_FORM_SLOT_DROPDOWN_FLOATING_CONFIG } from './ViewingFormSlotPicker.constants'
import {
  getViewingFormSlotDayItems,
  getViewingFormSlotDayLabel,
  getViewingFormSlotDays,
  getViewingFormSlotSelectedDay,
} from './ViewingFormSlotPicker.utils'
import { ViewingFormSlotPickerCalendar } from './ViewingFormSlotPickerCalendar'
import { ViewingFormSlotPickerList } from './ViewingFormSlotPickerList'
import { ViewingFormSlotPickerValue } from './ViewingFormSlotPickerValue'

import * as styles from './ViewingFormSlotPicker.module.css'

function ViewingFormSlotPicker({ isLoading, items, selectStatesRef }) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  const locale = useDateLocale()
  const timezone = useTimeZone()

  const { values } = useFormikContext()

  const [day, setDay] = useState(null)

  const listingId = values[VIEWING_FORM_FIELD_NAME.listing]?.value

  const days = getViewingFormSlotDays({ items, timezone })
  const selectedDay = getViewingFormSlotSelectedDay({ day, days })

  return (
    <FormikField
      Component={FormFieldSelectNG}
      Control={InputSelectControl}
      Select={InputSelect}
      controlProps={{
        borderless: !isMobileScreenSize,
        contentProps: {
          ValueItem: ViewingFormSlotPickerValue,
          inputProps: {
            placeholder: t('RentalPortal.ViewingFormSlotPlaceholderKey'),
          },
        },
      }}
      disabled={!listingId}
      dropdownFloatingConfig={VIEWING_FORM_SLOT_DROPDOWN_FLOATING_CONFIG}
      emptyValue={null}
      fieldComponentProps={{
        label: `${t('RentalPortal.ViewingFormSlotLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      listProps={{
        Empty: ViewingFormSlotSelectDropdownEmpty,
        Header: ViewingFormSlotPickerCalendar,
        ListContainer: ViewingFormSlotPickerList,
        className: styles.dropdown,
        emptyProps: { className: styles.empty, isLoading },
        headerProps: {
          days,
          disabled: isLoading,
          value: selectedDay,
          onChange: setDay,
        },
        listContainerProps: {
          dayLabel: getViewingFormSlotDayLabel({
            locale,
            selectedDay,
            timezone,
          }),
        },
      }}
      name={VIEWING_FORM_FIELD_NAME.slot}
      options={getViewingFormSlotDayItems({ items, selectedDay, timezone })}
      qaName={QA_NAME_VIEWING_FORM_SLOT}
      selectStatesRef={selectStatesRef}
    />
  )
}

export default ViewingFormSlotPicker
